import { render, staticRenderFns } from "./AdminTaskLayout.vue?vue&type=template&id=52a151ae&scoped=true"
import script from "./AdminTaskLayout.vue?vue&type=script&lang=js"
export * from "./AdminTaskLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminTaskLayout.vue?vue&type=style&index=0&id=52a151ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a151ae",
  null
  
)

export default component.exports